module.exports = __webpack_public_path__ + "static/media/processingMachine.ac7bdc6f.webp";